import { useTranslation } from 'react-i18next';
import { useGetPsNote } from '../../../../../api/ps-notes/ps-notes';
import { useDefaultOptions } from '../../../../../hooks/api';
import Modal from '../../../../modules/Modal';
import { PsNoteForm } from './PsNoteForm';

type Props = {
  isOpen: boolean;
  psDerivationId: number;
  chapterId: number;
  onClose: () => void;
  psNoteRefetch: () => void;
};
function PsNoteFormContainer({ isOpen, psDerivationId, chapterId, onClose, psNoteRefetch }: Props) {
  // isOpenがfalseの時も useGetPsNote Api が呼び出されていた
  // React 条件分岐のある箇所で Hooks を使うとエラーになるので、別のコンポーネント（PsNoteDisplay）内で表示処理を行なう。
  if (isOpen === false) return null;

  return (
    <PsNoteDisplay
      isOpen={isOpen}
      chapterId={chapterId}
      psDerivationId={psDerivationId}
      onClose={onClose}
      psNoteRefetch={psNoteRefetch}
    />
  );
}

export { PsNoteFormContainer };

interface PsNoteDisplayProps {
  isOpen: boolean;
  psDerivationId: number;
  chapterId: number;
  onClose: () => void;
  psNoteRefetch: () => void;
}

function PsNoteDisplay({ isOpen, psDerivationId, chapterId, onClose, psNoteRefetch }: PsNoteDisplayProps) {
  const {
    i18n: { language },
  } = useTranslation();

  const options = useDefaultOptions(language);
  const psNote = useGetPsNote(psDerivationId, chapterId, options);

  if (!psNote.data?.data) return null;

  return (
    <Modal active={isOpen} additionalClassName="popupfr800" displayCloseButton onClose={() => onClose()}>
      <PsNoteForm
        chapterId={chapterId}
        psDerivationId={psDerivationId}
        psNote={psNote.data.data}
        onClose={onClose}
        psNoteRefetch={psNoteRefetch}
      />
    </Modal>
  );
}
